import { FC, ReactNode } from 'react';

import { Flex, FlexProps, Typography } from 'antd';

interface IOfferSectionProps extends FlexProps {
	header: ReactNode;
}

export const OfferSection: FC<IOfferSectionProps> = ({ className, children, header, align, ...props }) => {
	return (
		<Flex {...props} className={className} vertical gap={8}>
			<Typography.Title level={5} style={{ margin: 0 }}>
				{header}
			</Typography.Title>

			<Flex vertical align={align}>
				{children}
			</Flex>
		</Flex>
	);
};
